var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import ShopActivityService from '../../../api/ShopActivityService';
import CommonService from "../../../api/CommonService";
var initFormData = {
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    business_Id: [],
    point_type: -1,
    keyword: '',
};
var ShopActivityRecordTable = (function (_super) {
    __extends(ShopActivityRecordTable, _super);
    function ShopActivityRecordTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.businessList = [];
        _this.formData = __assign({}, initFormData);
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.pointTypeList = [];
        _this.poolDate = {
            total_point: null,
            deduction_point: null,
            freeze_point: null,
            left_point: null,
        };
        _this.business_id = '';
        return _this;
    }
    ShopActivityRecordTable.prototype.created = function () {
        this.service = ShopActivityService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getBusinessList();
        this.getpointType();
        this.getList();
    };
    ShopActivityRecordTable.prototype.mounted = function () {
        var _this = this;
        var timeout = setTimeout(function () {
            clearTimeout(timeout);
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    ShopActivityRecordTable.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    ShopActivityRecordTable.prototype.getpointType = function () {
        var _this = this;
        this.service.pointType().then(function (res) {
            _this.pointTypeList = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityRecordTable.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            activity_id: this.activity_id,
            business_id: this.formData.business_Id.length !== 0 ? this.formData.business_Id.join(',') : this.business_id,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
            keywords: this.formData.keyword,
            shop_ids: this.formData.business_Id.join(','),
            point_type: this.formData.point_type
        };
        this.service.joinDetailPoint(Object.assign({}, pager, params)).then(function (res) {
            var DATA = Array.isArray(res.data.data) ? res.data.data : [];
            _this.listData = DATA;
            _this.poolDate = {
                total_point: res.data && res.data.total_point,
                deduction_point: res.data && res.data.deduction_point,
                freeze_point: res.data && res.data.freeze_point,
                left_point: res.data && res.data.left_point
            };
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityRecordTable.prototype.getBusinessList = function () {
        var _this = this;
        var params = {
            area_ids: 86000000,
            real: '0',
        };
        this.commonService.getShop(params).then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            _this.businessList = listData;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ShopActivityRecordTable.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    ShopActivityRecordTable.prototype.search = function () {
        this.$refs.pagination && this.$refs.pagination.clear();
        this.getList();
    };
    ShopActivityRecordTable.prototype.exportResult = function () {
    };
    ShopActivityRecordTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: __assign({}, mapActions(["getAuth"])),
        })
    ], ShopActivityRecordTable);
    return ShopActivityRecordTable;
}(Vue));
export default ShopActivityRecordTable;
